export const positions = ['Goalkeeper', 'Defender', 'Midfielder', 'Attacker'] as const;
